export default __webpack_public_path__ + "static/media/548.6510b5cc.svg";